import React from "react";
import exclaims from "assets/exclaims.json";
import { arrayRandom } from "Utils";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { thin } from "@fortawesome/fontawesome-svg-core/import.macro";

export default function EmptyState(props) {
    return (
        <div className="my-4 space-y-4 text-center text-gray-700">
            <FontAwesomeIcon
                className="text-5xl text-gray-300"
                icon={thin("folder-open")}
            />
            <div className="text-xl font-bold">{arrayRandom(exclaims)}</div>
            <hr />
            <div className="font-normal tracking-tighter">
                There doesn't seem to be anything here. Check out our{" "}
                <a
                    href="/help/getting-started.html"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-green-700 underline"
                >
                    getting started guide
                </a>
                , or let's add some content:
            </div>
            <div className="mx-auto max-w-lg divide-y divide-gray-200 text-left">
                <div className="py-4 font-normal tracking-tighter">
                    <Link className="text-lg" to="/app/article/new">
                        New article
                    </Link>
                    <div className="text-sm text-gray-500">
                        Articles are the base content for all CEO sites.
                    </div>
                </div>
                <div className="py-4 font-normal tracking-tighter">
                    <Link className="text-lg" to="/app/page/new">
                        New page
                    </Link>
                    <div className="text-sm text-gray-500">
                        Pages are useful for static content, like contact info
                        and about us.
                    </div>
                </div>
                <div className="py-4 font-normal tracking-tighter">
                    <Link
                        className="text-lg"
                        to="/app/custom-content/entry/new"
                    >
                        New custom entry
                    </Link>
                    <div className="text-sm text-gray-500">
                        Custom entries are for custom content that doesn't fit
                        standard moulds.
                    </div>
                </div>
                <div className="py-4 font-normal tracking-tighter">
                    <Link className="text-lg" to="/app/container/new">
                        New section or container
                    </Link>
                    <div className="text-sm text-gray-500">
                        Group content into logical containers, like "Sports" and
                        "Editor's Picks."
                    </div>
                </div>
            </div>
        </div>
    );
}
